import { useContext } from 'react';
import { useMutation } from '@apollo/client/react';

import UserThumbnail from '@atom/components/common/UserThumbnail';
import { USER_UPDATE } from '@atom/graph/user';
import {
  AtomMap,
  DEFAULT_MAP_CENTER,
  getGoogleShapeCenter,
  getUserSvg,
} from '@atom/map';
import { LocationGeometry } from '@atom/types/geojson';
import { EditTarget } from '@atom/types/map';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

import UserContext from '../UserContext';

const LOCATION_EDIT_ZOOM = 14;

const UserDetailMap = () => {
  const { user, refetch } = useContext(UserContext);

  const [updateUser] = useMutation(USER_UPDATE, {
    onCompleted: () => refetch(),
  });

  const canEdit = hasRolePermissions(ROLE_SETS.ORG_ADMIN);
  const center = getGoogleShapeCenter(user?.location) ?? DEFAULT_MAP_CENTER;

  const fullName = `${user.firstName} ${user.lastName}`;

  const target: EditTarget = {
    id: user.id,
    name: fullName,
    type: 'user',
    icon: <img src={getUserSvg(false)} alt="" />,
    activeIcon: <img src={getUserSvg(true)} alt="" />,
    listIcon: <UserThumbnail image={user.photoUrl} alt={fullName} />,
    location: user.location ?? null,
    canEdit,
  };

  const handleSave = (location: LocationGeometry) => {
    updateUser({
      variables: {
        input: {
          id: user.id,
          location,
        },
      },
    });
  };

  return (
    <AtomMap
      initialViewState={{ center, zoom: LOCATION_EDIT_ZOOM }}
      search="editable"
      editing={{
        targets: [target],
        onSave: handleSave,
      }}
    />
  );
};

export default UserDetailMap;
